<template>
  <div class="aside-box">
    <div class="global-fab-wrapper">
      <!-- trigger="click" -->
      <el-popover placement="top" :width="200" :transition="''" popper-class="custom-popover" v-model="popoverVisible">
        <template #reference>
          <div class="global-fab">
            <img src="@/assets/images/kf.png">
            <!-- <i class="el-icon-s-custom"></i> -->
          </div>
        </template>
        <div class="service-pop">
          <div v-if="serviceUrl" class="service-box">
            <p>请添加企业微信</p>
            <el-image style="width: 120px; height: 120px" :src="serviceUrl" :preview-src-list="serviceList">
            </el-image>

          </div>

          <div class="empty-pop" v-else>
            <img src="@/assets/images/empty.png" />
            <p style="text-align: center;">暂无客服</p>
          </div>
        </div>
      </el-popover>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SiteAside',
  data() {
    return {
      // items: [
      //   // { label: '咨询客服', icon: '💬' },
      //   // { label: '企业定制', icon: '🏢' },
      //   // { label: '报价方案', icon: '📋' },
      //   // { label: '申请试用', icon: '✨' }
      // ],
      // serviceUrl: '',
      // serviceList: []
      popoverVisible: false
    }
  },
  computed: {
    // 实时响应vuex变化，store一旦更新自动触发视图刷新
    serviceUrl() {
      return this.$store.getters.customerUrl || ''
    },
    serviceList() {
      return this.serviceUrl ? [this.serviceUrl] : []
    }
  },
  mounted() {
    // this.serviceUrl = this.$store.state.customerUrl || '';
    // this.serviceList[0] = this.serviceUrl;
  },
  methods: {
    openPopover() {
      this.popoverVisible = true
    },
    closePopover() {
      this.popoverVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.aside-box {
  position: fixed;
  right: 30px;
  bottom: 134px;
  z-index: 999;
}

.aside-cont {
  border: 1px solid #ececec;
  border-bottom: 0;
  background-color: #fff;
  width: 72px;
  height: 72px;
  padding: 12px 0;
  transition: all 0.3s;

  &:last-child {
    border-bottom: 1px solid #ececec;
  }

  &:hover {
    background: linear-gradient(270deg, #49a1fa, #0067ff);
    border-color: transparent;

    .white-icon {
      display: block;
    }

    .blue-icon {
      display: none;
    }

    .text {
      color: #fff;
    }
  }

  .img-box {
    margin-bottom: 4px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon {
    font-size: 18px;
    line-height: 24px;
  }

  .white-icon {
    display: none;
  }

  .text {
    display: block;
    font-size: 12px;
    color: #666;
    line-height: 1.2;
    transform: scale(0.85);
  }
}


.global-fab-wrapper {
  width: 56px;
  height: 56px;
  -webkit-tap-highlight-color: transparent;
  tap-highlight-color: transparent;
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.global-fab-wrapper:hover {
  transform: scale(1.1);
}

.global-fab {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  // background-color: #409EFF;
  background-color: #3584FD;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;

  img{
    width: 40px;
    height: 40px;
  }
}

.global-fab:hover {
  // background-color: #66b1ff;
  background-color: #409EFF;
  box-shadow: 0 6px 20px rgba(64, 158, 255, 0.5);
}

.service-pop {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 200px;
  background: #F7F8FC;
}

.service-box {
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    font-size: 16px;
    color: #333;
    font-weight: 600;
  }
}

.empty-pop {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  img {
    width: 120px;
    margin-bottom: 20px;
  }

  p {
    margin: 0;
  }
}
</style>

<style lang="scss">
.custom-popover {
  border: none !important;
  border-radius: 8px !important;
  overflow: hidden;
  background: #F7F8FC !important;
  border: none !important;
  padding: 0 !important;

}
</style>
